import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const headers = {};
    const token = localStorage.getItem('access_token');
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const userId = localStorage.getItem('user_id');
    if (userId) headers['X-User-Id'] = userId;
    return headers;
}

/**
 * Fetch data-library items where a KB entity was detected by the data-item NER pipeline.
 *
 * These are the user's uploaded files (scoped to global + own + shared), distinct from
 * report-source documents returned by {@link useEntityMentions}. Mirrors that hook's shape.
 *
 * @param {string} entityId  Wikidata Q-number (e.g. "Q794") or numeric entity_id.
 * @returns {{ dataItems: Array, loading: boolean, error: Error|null }}
 */
export function useEntityDataItems(entityId) {
    const [dataItems, setDataItems] = useState([]);
    const [loading, setLoading] = useState(!!entityId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!entityId) {
            setDataItems([]);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        fetch(`${BASE}/api/entities/${encodeURIComponent(entityId)}/data-items`, {
            headers: authHeaders(),
        })
            .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
            .then(data => {
                if (!cancelled) {
                    setDataItems(Array.isArray(data.dataItems) ? data.dataItems : []);
                    setLoading(false);
                }
            })
            .catch(err => {
                if (!cancelled) {
                    setError(err);
                    setLoading(false);
                }
            });

        return () => { cancelled = true; };
    }, [entityId]);

    return {dataItems, loading, error};
}
